module.exports = __webpack_public_path__ + "img/moved_zh.7cb597d3.png";